module.exports = __webpack_public_path__ + "img/pic8.69407957.png";